import { Option } from '~components/commons/MultiSelectDropdown/MultiSelectDropdown';
import { SelectOption } from '~components/commons/select/select';

import { WEEK_DAYS } from '~constants/index';
import { ENGLISH_LANGUAGE_ID, SPANISH_LANGUAGE_ID } from '~constants/languages';
import { phoneNumberInternationalRegExp } from '~constants/validation/validationRegExps';

export const BUSINESS_NAME_FIELD_LABEL = 'Business Name';
export const FIRST_NAME_FIELD_LABEL = 'First Name';
export const LAST_NAME_FIELD_LABEL = 'Last Name';
export const EMAIL_FIELD_LABEL = 'Email';
export const PHONE_FIELD_LABEL = 'Phone';

export const BUSINESS_NAME_MAX_LENGTH = 60;
export const FIRST_NAME_MAX_LENGTH = 30;
export const LAST_NAME_MAX_LENGTH = 30;
export const PHONE_MAX_LENGTH = 10;

export const VALIDATION_REGEX = {
	email:
		// eslint-disable-next-line no-empty-character-class
		/([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+/, // https://stackoverflow.com/a/14075810
	phone: /^[0-9]{10}$/,
	phoneInternational: phoneNumberInternationalRegExp,
	zip: /^[0-9]{5}$/,
};
export const CUSTOMER_TYPE = {
	Commercial: 'Commercial',
	Retail: 'Retail',
};

export const wizardSteps = {
	settings: 'settings',
	billTo: 'billTo',
	terms: 'terms',
	invoiceAutomationSettings: 'invoiceAutomationSettings',
};

export const dataLabelMap = {
	businessName: 'Business Name',
	contactFirstName: 'First Name',
	contactLastName: 'Last Name',
	contactEmails: 'Email',
	contactTelephone: 'Phone',
	address: 'Address',
	suiteOrUnit: 'Unit # / Suite',
	city: 'City',
	state: 'State',
	zipCode: 'ZIP',
};

export const CUSTOMERS_SOURCES = {
	ALL: 'ALL',
	RETAIL: 'RETAIL',
	COMMERCIAL: 'COMMERCIAL',
} as const;

export const CUSTOMER_TYPE_ROUTES = {
	ALL_CUSTOMERS: '/all-customers',
	RETAIL_CUSTOMERS: '/retail-customers',
	COMMERCIAL_CUSTOMERS: '/commercial-customers',
};

export const MEMO_MAX_LENGTH = 100;

export const MAX_GROUP_NAME_LENGTH = 50;

export const WIZARD_SAVE_BUTTON_ID = 'wizardSaveButton';

export const enum INVOICE_AUTOMATION_SETTINGS_PERIOD {
	WEEK = 'WEEK',
	MONTH = 'MONTH',
	DAY = 'DAY',
}

export const enum INVOICE_AUTOMATION_SETTINGS_CREATION_TYPE {
	MANUAL = 'MANUAL',
	AUTO = 'AUTO',
}

export const MAX_INVOICE_AUTOMATION_SCHEDULES = 3;

export const FREQUENCY_SELECT_OPTIONS: SelectOption[] = [
	{ label: '1', value: 1 },
	{ label: '2', value: 2 },
	{ label: '3', value: 3 },
	{ label: '4', value: 4 },
	{ label: '5', value: 5 },
	{ label: '6', value: 6 },
	{ label: '7', value: 7 },
	{ label: '8', value: 8 },
	{ label: '9', value: 9 },
	{ label: '10', value: 10 },
	{ label: '11', value: 11 },
	{ label: '12', value: 12 },
];

export const PERIOD_SELECT_OPTIONS: SelectOption[] = [
	{ label: 'Month(s)', value: INVOICE_AUTOMATION_SETTINGS_PERIOD.MONTH },
	{ label: 'Week(s)', value: INVOICE_AUTOMATION_SETTINGS_PERIOD.WEEK },
];

export const DAY_PERIOD_SELECT_OPTION: SelectOption = {
	label: 'Day(s)',
	value: INVOICE_AUTOMATION_SETTINGS_PERIOD.DAY,
};

/**
 * Every known period option — use it to resolve a stored period, not to render the dropdown.
 */
export const ALL_PERIOD_SELECT_OPTIONS: SelectOption[] = [
	...PERIOD_SELECT_OPTIONS,
	DAY_PERIOD_SELECT_OPTION,
];

/**
 * Daily automations always run every day, so the frequency is locked to 1.
 */
export const DAILY_AUTOMATION_FREQUENCY = 1;

export const WEEKDAY_SELECT_OPTIONS: Option<number>[] = [
	{ label: WEEK_DAYS[0], value: 0 },
	{ label: WEEK_DAYS[1], value: 1 },
	{ label: WEEK_DAYS[2], value: 2 },
	{ label: WEEK_DAYS[3], value: 3 },
	{ label: WEEK_DAYS[4], value: 4 },
	{ label: WEEK_DAYS[5], value: 5 },
	{ label: WEEK_DAYS[6], value: 6 },
];

export enum CustomerDetailsTabsValues {
	Details = 'details',
	Orders = 'orders',
	Messages = 'messages',
	Cards = 'cards',
	Calls = 'calls',
}

export const SERVICES_ORDERED = {
	DRY_CLEANING: 'Dry Cleaning',
	TAILORING: 'Tailoring',
	LAUNDRY: 'Laundry',
} as const;

export const LAST_DAY_OPTION_VALUE = 'last';

export const LAST_DAY_OPTION: SelectOption<string> = {
	label: 'Last',
	value: LAST_DAY_OPTION_VALUE,
};
